import Head from 'next/head'
import Hero from '@/components/Hero'
import { getCities, getBlogs, getFAQs } from '@/lib/data'
import CityLinks from '@/components/CityLinks'
import BlogCard from '@/components/BlogCard'
import SubmitForm from '@/components/SubmitForm'
import FeaturedBlogs from '@/components/FeaturedBlogs'
import StepsSection from '@/components/StepsSection'
import FAQ from '@/components/FAQ'
import CookieConsent from '@/components/CookieConsent'
import Image from 'next/image'
import dynamic from 'next/dynamic'



export default function Home({ cities, blogs, faqs }: any) {
  return (
    <>
      <Head>
        <title>Autoverwertung & KFZ-Ankauf | Deutschland</title>
        <meta name="description" content="Kostenlose Abholung in Deutschland ✓ Verwertung von Schrottautos ✓ Unfallwagen ✓ Autos mit Totalschaden ✓ Jetzt Termin sichern und umweltgerecht entsorgen!" />
        <meta property="og:title" content="Autoverwertung & KFZ-Ankauf | Deutschland" />
        <meta property="og:description" content="Kostenlose Abholung in Deutschland ✓ Verwertung von Schrottautos ✓ Unfallwagen ✓ Autos mit Totalschaden ✓ Jetzt Termin sichern und umweltgerecht entsorgen!" />
        <meta property="og:image" content="/images/cars/reccar.webp"  />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://autoverwertungs.de/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Autoverwertung & KFZ-Ankauf | Deutschland" />
        <meta name="twitter:description" content="Kostenlose Abholung in Deutschland ✓ Verwertung von Schrottautos ✓ Unfallwagen ✓ Autos mit Totalschaden ✓ Jetzt Termin sichern und umweltgerecht entsorgen!" />
        <meta name="twitter:image" content="/images/cars/reccar.webp"  />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="UTF-8" />
        <meta lang='de' />
        {/* Schema.org LD+JSON for first 4 cities */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify([
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Autoverwertung Aachen",
            "image": "/images/cars/car-1.webp",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Aachen",
              "addressCountry": "DE"
            },
            "description": "Kostenlose Abholung in Aachen ✓ Verwertung von Schrottautos ✓ Unfallwagen ✓ Autos mit Totalschaden ✓ Jetzt Termin sichern und umweltgerecht entsorgen!",
            "url": "https://autoverwertungs.de/aachen"
          },
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Autoverwertung Bielefeld",
            "image": "/images/cars/car-2.webp",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Bielefeld",
              "addressCountry": "DE"
            },
                  "description": "Kostenlose Abholung in Bielefeld ✓ Verwertung von Schrottautos ✓ Unfallwagen ✓ Autos mit Totalschaden ✓ Jetzt Termin sichern und umweltgerecht entsorgen!",
                  "url": "https://autoverwertungs.de/bielefeld"
          },
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Autoverwertung Bochum",
            "image": "/images/cars/car-3.webp",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Bochum",
              "addressCountry": "DE"
            },
            "description": "Kostenlose Abholung in Bochum ✓ Verwertung von Schrottautos ✓ Unfallwagen ✓ Autos mit Totalschaden ✓ Jetzt Termin sichern und umweltgerecht entsorgen!",
            "url": "https://autoverwertungs.de/bochum"
          },
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Autoverwertung Bottrop",
            "image": "/images/cars/car-4.webp",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Bottrop",
              "addressCountry": "DE"
            },
                  "description": "Kostenlose Abholung in Bottrop ✓ Verwertung von Schrottautos ✓ Unfallwagen ✓ Autos mit Totalschaden ✓ Jetzt Termin sichern und umweltgerecht entsorgen!",
                  "url": "https://autoverwertungs.de/bottrop"
          }
        ]) }} />
      </Head>
      <Hero />
      {/* Our Services Section */}
      <section className="container mx-auto px-4 py-8 md:py-12 lg:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Service Description */}
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-gray-900">
              Unsere Services
            </h2>
            <div className="space-y-4 text-gray-700 text-base sm:text-lg leading-relaxed">
              <p>
                <strong>Professionelle Autoverwertung und Kfz-Ankauf</strong> – Wir sind Ihr zuverlässiger Partner für die umweltgerechte Verwertung von Fahrzeugen aller Art. Mit über 10 Jahren Erfahrung bieten wir schnelle, unkomplizierte und faire Lösungen für Ihren Gebrauchtwagen, Unfallwagen oder Schrottwagen.
              </p>
              <p>
                <strong>Kostenlose Abholung bundesweit:</strong> Wir holen Ihr Fahrzeug direkt bei Ihnen ab – schnell, zuverlässig und völlig kostenfrei. Egal ob in Berlin, München, Hamburg oder eine andere Stadt in Deutschland.
              </p>
              <ul className="space-y-3 mt-6">
                <li className="flex items-start gap-3">
                  <span className="text-[#0066CC] font-bold text-xl">✓</span>
                  <span>Faire Preise und Sofortzahlung in bar</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#0066CC] font-bold text-xl">✓</span>
                  <span>Professionelle Beratung und schnelle Abwicklung</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#0066CC] font-bold text-xl">✓</span>
                  <span>Umweltgerechte Entsorgung nach allen Vorschriften</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-[#0066CC] font-bold text-xl">✓</span>
                  <span>Alle Fahrzeugtypen: PKW, Transporter, Nutzfahrzeuge</span>
                </li>
              </ul>
                <button
                className="pt-4 bg-transparent text-[#0066CC] font-semibold underline hover:text-[#004BA6] transition-colors duration-200"
                onClick={() => {
                  const form = document.getElementById('contact-form');
                  if (form) {
                  form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                onMouseEnter={e => e.currentTarget.classList.add('animate-bounce')}

                >
                Kontaktieren Sie uns noch heute für ein kostenlos Angebot!
                </button>
            </div>
          </div>
          
          {/* Service Image */}
          <div className="relative h-96 sm:h-[450px] lg:h-[500px] rounded-lg overflow-hidden shadow-lg">
            <Image
              src="/images/cars/car-1.webp"
              alt="Professionelle Autoverwertung und KFZ-Ankauf Service"
              fill
              quality={50}
              sizes="(max-width: 768px) 100vw, 50vw"
              className="object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <StepsSection />

      <FeaturedBlogs blogs={blogs} />

      <FAQ faqs={faqs} />

      <section className="bg-gray-50 py-8 md:py-12 lg:py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 md:mb-8">Unsere Standorte</h2>
          <CityLinks cities={cities} />
        </div>
      </section>

      {/* Cookie Consent Popup */}
      <CookieConsent />
    </>
  )
}

export async function getStaticProps() {
  const cities = await getCities()
  const blogs = await getBlogs()
  const faqs = await getFAQs()
  return { props: { cities, blogs, faqs } }
}
